import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center","margin-bottom":"20px"} }, [
  /*#__PURE__*/_createElementVNode("h1", null, "开票申请成功"),
  /*#__PURE__*/_createElementVNode("p", null, "您的开票申请已提交")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "form-dialog__title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "开票信息")
], -1)
const _hoisted_3 = { class: "form-dialog__content" }
const _hoisted_4 = { class: "form-dialog__w280" }
const _hoisted_5 = { class: "form-dialog__w280" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "form-dialog__title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "发票邮寄信息")
], -1)
const _hoisted_7 = { class: "form-dialog__content" }
const _hoisted_8 = { class: "form-dialog__w280" }
const _hoisted_9 = { class: "form-dialog__w280" }
const _hoisted_10 = { class: "form-dialog__w280" }
const _hoisted_11 = { class: "form-dialog__w280" }

import {
  BaseDialog,
  BaseTextContent,
  BaseButton,
  BaseForm,
  BaseFormItem
} from 'xrk-components';
import { MakeOutAnInvoiceDkData } from '@V/invoice/src/data-source/types';
import { formatter } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-wtdk-4-dialog',
  props: {
    remove: {},
    payload: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "850px",
    class: "form-dialog",
    title: "申请结果",
    "model-value": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), { onClick: _ctx.remove }, {
        default: _withCtx(() => [
          _createTextVNode("确认")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_unref(BaseForm), {
            ref: "formRef",
            "label-position": "right",
            model: _ctx.payload
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(BaseFormItem), {
                    label: "开票人数",
                    prop: "invoicePeopleNumber"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.payload.invoiceSubmitToSave.invoicePeopleNumber) + "人 ", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(BaseFormItem), {
                    label: "价税合计",
                    prop: "totalAmount"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(formatter).fen2yuan(_ctx.payload.invoiceSubmitToSave.totalAmount)) + "元 ", 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(BaseFormItem), {
                    label: "收件人",
                    prop: "name"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.payload.address.name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(BaseFormItem), {
                    label: "联系方式",
                    prop: "phone"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.payload.address.phone), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(BaseFormItem), {
                    label: "发票邮寄地址",
                    prop: "mailAddress"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.payload.address.mailAddress), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(BaseFormItem), {
                    label: "电子邮箱",
                    prop: "email"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.payload.address.email), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})